import {createContext} from 'react';

export const PageContext = createContext({});

export const PageProvider = PageContext.Provider

export default PageContext
